<script>
import { filter } from 'lodash-es';
import ValidationMixin from '../../mixins/validatorMixin';

export default {
  name: 'ItineraryDayProgramLocationModal',
  props: {
    dayProgram: {
      type: Object,
      default: () => {},
    },
    countriesAndAreas: {
      type: Array,
      default: () => [],
    },
    dayProgramSaveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toggled: true,
      countryIdSelected: null,
      areaIdSelected: null,
      valid: true,
    };
  },
  methods: {
    clearAreaIdSelected() {
      this.areaIdSelected = null;
    },
    saveDayProgramLocation() {
      this.$emit('saveDayProgramLocation', {
        dayProgramId: this.dayProgram.id,
        countryId: this.countryIdSelected,
        areaId: this.areaIdSelected,
      });
    },
    resetDayProgramLocation() {
      this.$emit('saveDayProgramLocation', {
        dayProgramId: this.dayProgram.id,
        countryId: null,
        areaId: null,
      });
    },
  },
  computed: {
    getAreasForSelectedCountry() {
      if (!this.countryIdSelected) {
        return [];
      }
      const country = filter(this.countriesAndAreas, ca => ca.id === this.countryIdSelected);
      return country[0].areas;
    },
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('cancel');
      }
    },
  },
  created() {
    if (this.dayProgram.countryId) {
      this.countryIdSelected = this.dayProgram.countryId;
      this.areaIdSelected = this.dayProgram.areaId;
    }
  },
  mixins: [ValidationMixin],
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px"
  >
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>map</v-icon>
        {{ $t('itinerary.locationModal.title') }}
        | {{ dayProgram.description }}
      </v-flex>
      <v-divider light/>
      <v-form
        v-model="valid"
        ref="form"
      >
        <v-layout row wrap>
          <v-flex sm12 pa-3>
            <v-chip
              color="primary"
              text-color="white"
            >
              {{ dayProgram.country }} - {{ dayProgram.area }}
            </v-chip>
          </v-flex>
          <v-flex sm12 pa-3>
            <v-select
              v-model="countryIdSelected"
              :items="countriesAndAreas"
              :label="$t('itinerary.locationModal.labels.countries')"
              :rules="[rules.required]"
              :loading="dayProgramSaveLoading"
              :disabled="dayProgramSaveLoading"
              item-text="alias"
              item-value="id"
              @change="clearAreaIdSelected"
            />
          </v-flex>
          <v-flex sm12 px-3>
            <v-select
              v-model="areaIdSelected"
              :items="getAreasForSelectedCountry"
              :label="$t('itinerary.locationModal.labels.areas')"
              :disabled="!countryIdSelected || dayProgramSaveLoading"
              :rules="[rules.required]"
              :loading="dayProgramSaveLoading"
              item-text="name"
              item-value="id"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex
            v-html="$t('itinerary.locationModal.disclaimer')"
            sm12
            pa-3
          />
        </v-layout>
        <v-layout justify-end>
          <v-btn
            :loading="dayProgramSaveLoading"
            color="red darken-3"
            flat
            @click="resetDayProgramLocation"
          >
            {{ $t('buttons.reset') }}
          </v-btn>
          <v-spacer/>
          <v-btn
            :loading="dayProgramSaveLoading"
            color="red darken-1"
            flat
            @click="toggled = false"
          >
            {{ $t('inputs.actions.cancel') }}
          </v-btn>
          <v-btn
            :disabled="!valid || areaIdSelected === dayProgram.areaId"
            :loading="dayProgramSaveLoading"
            color="blue darken-1"
            flat
            @click="saveDayProgramLocation"
          >
            {{ $t('inputs.actions.save') }}
          </v-btn>
        </v-layout>
      </v-form>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramLocationModal.vue